import {CarFeed} from "./car-feed";

export class UpFeed extends CarFeed {

}
